import React from 'react'
import { useIntl } from 'react-intl'
import { Headline } from '../../../'

const CartHeader = ({ productsQuantity = 0 }: { productsQuantity: number }) => {
  const { formatMessage } = useIntl()

  return (
    <div className='checkout-item checkout-left justify-center'>
      <Headline tag='h3'>
        <div className='flex h-full items-center space-x-2 pl-0 text-2xl md:text-inherit'>
          <div>
            {formatMessage({
              id: 'msp.cart.title',
              defaultMessage: 'Cart'
            })}
          </div>
          {productsQuantity > 0 && <div>{` (${productsQuantity})`}</div>}
        </div>
      </Headline>
    </div>
  )
}

export default CartHeader
